<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-image image-element" id="full-page-image-2">
<div class="image-element-block image-element-aspect-tall">
<div class="image-element-size-container">
<img alt="Full Page Image" class="image-element-image" src="images/jason-berry-christ-centered-fitness-_043-cropped-reversed.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// full-page-image-2.vue?7c04685f